module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.a35a722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_hero.png
// module id = IELe
// module chunks = 0